"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Smartphone = function Smartphone(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "5",
    y: "5.02",
    width: "14",
    height: "14",
    style: {
      fill: '#024965'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5,20v1.5A2.5,2.5,0,0,0,7.5,24h9a2.5,2.5,0,0,0,2.5-2.5V20Zm7,2.5a1,1,0,1,1,1-1A1,1,0,0,1,12,22.52Z",
    style: {
      fill: '#024965'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19,4V2.52A2.5,2.5,0,0,0,16.5,0h-9A2.5,2.5,0,0,0,5,2.52V4ZM9.5,2h5a.5.5,0,0,1,0,1h-5a.5.5,0,0,1,0-1Z",
    style: {
      fill: '#024965'
    }
  }));
};

var _default = Smartphone;
exports["default"] = _default;